import lightGallery from "lightgallery";
// import { LightGalleryCoreStrings } from "lightgallery/lg-settings";

// Plugins
import lgVideo from "lightgallery/plugins/video";

export default (container) => {
  lightGallery(container, {
    plugins: [lgVideo],
    speed: 500,
    download: false,
    closeOnTap: false,
    hideScrollbar: true,
    defaultCaptionHeight: 150,
    supportLegacyBrowser: false,
    mobileSettings: { controls: true },
    // strings: { mediaLoadingFailed: "test" } as LightGalleryCoreStrings,
    // ... other settings
  });

  const subs = document.querySelectorAll(".lg-sub-html");
  subs.forEach((sub) => sub.classList.add("line-clamp-5", "!pb-1"));
};
